import Aos from "aos";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/header";
import Footer from "../../components/footer";
import LogoCarousel from "../../components/logo-carrosel";
import RequestForm from "../../components/RequestForm";
import Stage from "../../components/stage";
import '../../assets/styles/global.css'
import appExample from "../../assets/images/app-example.jpg";
import androidStudioLogo from '../../assets/images/logo-android-studio.png';
import mongoLogo from '../../assets/images/logo-mongodb.png';
import fastAPILogo from '../../assets/images/logo-fastapi.png';
import firebaseLogo from '../../assets/images/logo-firebase.png';
import javascriptLogo from '../../assets/images/logo-javascript.png';
import mysqlLogo from '../../assets/images/logo-mysql.png';
import phpLogo from '../../assets/images/logo-php.png';
import sqlServerLogo from '../../assets/images/logo-sql-server.png';
import reactLogo from '../../assets/images/logo-reactjs.png';
import ServiceDetails from "../../components/service-details";
import Card from "../../components/card";
import whatIsDatabase from "../../assets/images/whats_is_database.png"
import sql from "../../assets/images/sql.png"
import nosql from "../../assets/images/nosql.png"
import CardInline from "../../components/card-inline";


function Database() {

    const {t} = useTranslation();

    const logos = [
        { src: androidStudioLogo, alt: 'React Logo' },
        { src: mongoLogo, alt: 'React Logo' },
        { src: fastAPILogo, alt: 'React Logo' },
        { src: firebaseLogo, alt: 'React Logo' },
        { src: javascriptLogo, alt: 'React Logo' },
        { src: mysqlLogo, alt: 'React Logo' },
        { src: phpLogo, alt: 'React Logo' },
        { src: sqlServerLogo, alt: 'React Logo' },
        { src: reactLogo, alt: 'React Logo' },
    ];

    const typesApp = [
        {headerText: '', img: sql, altImg: t('database_types.itens.0.title'), textTitle: t('database_types.itens.0.title'), text: "\n", imgStyle: {borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}},
        {headerText: '', img: nosql, altImg: t('database_types.itens.1.title'), textTitle: t('database_types.itens.1.title'), text: "", imgStyle: {borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}},
    ]

    const cardInline = [
        {
            title: t('database_types.itens.0.title'),
            description: t('database_types.itens.0.description')
        },
        {
            title: t('database_types.itens.1.title'),
            description: t('database_types.itens.1.description')
        },

    ]
    

    useEffect(() => {
        Aos.init({
          duration: 1000, // Define a duração da animação
        });
      }, []);

    return(
        <div>
            <Header pageName={t('database')} headerName={t('database')} headerText={t('database')} headerStyle="header-60" buttonName ={t('contact_us')} buttonLink="/contact"/>
            <section>
                <ServiceDetails explandServiceTile={t('database_explanation.title')} explandServiceDescription={t('database_explanation.description')} serviceNeedsTitle={t('do_you_need_database.title')} serviceNeedsDescription0={t('do_you_need_database.description.0.text')} serviceNeedsDescription1={t('do_you_need_database.description.1.text')} imageBg={whatIsDatabase}/>
            </section>
            <section>
                <Card cardTitle={t('database_types.title')} typesApp={typesApp} />
            </section>
            <section>
                <CardInline card={cardInline}  />
            </section>
            <section>
                <LogoCarousel logos={logos}  />
            </section>

            <section>
                <RequestForm />
            </section>
            
            <section>
                <Stage />
            </section>

            <Footer />
        </div>
    )
}

export default Database;